import styles from "./RoadmapItem.module.css";

// React
import React from "react";
import { NavLink } from "react-router-dom";

// Tools
import { Status } from "tools/Enums";
import GetModule from "tools/getModule";

// components
import FeatureTitleAndDevDays from "components/FeatureTitleAndDevDays";

export default function RoadmapItem({ status, feature }) {
	const getStatusStyle = () => {
		if (status === Status.Planned) return ["infoBlue", "hoverBlue"];
		if (status === Status.InProgress) return ["infoYellow", "hoverYellow"];
		if (status === Status.Live) return ["infoGreen", "hoverGreen"];
	};
	return (
		<>
			<NavLink to={{ pathname: `/comments/${feature.idFeature}` }}>
				<div className={[styles.container, styles[getStatusStyle()[1]]].join(" ")}>
					<div className={[styles.card, styles[getStatusStyle()[0]]].join(" ")}>
						<FeatureTitleAndDevDays feature={feature} />
						<div className={styles.module}>
							<span className={styles.span}>{GetModule.getName(feature.module)} </span>
							Module
						</div>
					</div>
				</div>
			</NavLink>
		</>
	);
}
